<script lang="ts">
    import { parseDate } from '@internationalized/date';
    import dayjs from 'dayjs';

    import { trans } from '$assets/shop-translator.js';
    import type { DateRange } from '$saga/utils/date';
    import {
        datesInfos,
        dateValue,
        isModalOpen,
        modalStep,
        selectedPrice,
    } from '$saga/views/Tour/store';
    import VisibleDatesDesktop from '$saga/views/Tour/VisibleDates/Fit/VisibleDatesDesktop.svelte';
    import VisibleDatesMobile from '$saga/views/Tour/VisibleDates/Fit/VisibleDatesMobile.svelte';
    import type {
        MinPriceDays,
        MinPriceMonth,
        MonthlyPrices,
    } from '$saga/views/Tour/VisibleDates/types';
    import UnavailableTour from '$saga/views/Tour/VisibleDates/UnavailableTour.svelte';

    export let closedSales,
        disabled: boolean,
        searchUrl: string,
        cheapestMonthlyPrices: MonthlyPrices,
        cheapestDailyPrices: MinPriceDays,
        isBookable: boolean;

    let closedSalesFormatted: DateRange[];
    $: {
        const parsedClosedSales = JSON.parse(closedSales);
        closedSalesFormatted = parsedClosedSales.map(
            (closedSale: { startDate: string; endDate: string }) => {
                return {
                    startDate: dayjs(closedSale.startDate),
                    endDate: dayjs(closedSale.endDate),
                };
            },
        );
    }
    let minPricePerMonths: MinPriceMonth[] = [];
    // transform cheapestMonthlyPrices into an array of object container a dayjs date, and a number "price"
    $: {
        // key is the date
        minPricePerMonths = Object.keys(cheapestMonthlyPrices).map((key) => ({
            date: dayjs(key),
            price: cheapestMonthlyPrices[key]?.amount,
            quantile: cheapestMonthlyPrices[key]?.quantile,
        }));
    }

    const handleSelectedDate = (selectedDate: string | undefined) => {
        if (selectedDate == null) return;

        const date = dayjs(selectedDate).format('YYYY-MM-DD');
        const selected = date ? cheapestDailyPrices[date] : null;

        if (selected) {
            $selectedPrice = {
                originalPrice: selected.originalAmount
                    ? selected.originalAmount / 100
                    : null,
                rebateAmount: selected.rebateAmount
                    ? selected.rebateAmount / 100
                    : null,
                actualPrice: selected.amount / 100,
            };
            $dateValue = parseDate(date);
            $datesInfos = {
                price: selected.rebateAmount
                    ? selected.rebateAmount / 100
                    : (selected.originalAmount ?? 0) / 100,
                remainingStock: null,
                statusName: '',
                selectedDate: selectedDate,
            };
            $modalStep = 2;
            $isModalOpen = true;
        }
    };
</script>

<h2 class="pb-m text-[32px] font-semibold text-content-neutral">
    {trans('tour.dates.title')}
</h2>
<!-- If FIT is disabled -->
{#if disabled}
    <UnavailableTour {searchUrl} />
{:else}
    <div class="w-full bg-white p-s text-content-neutral desktop:p-m">
        <div class="flex flex-col gap-m">
            <h3 class="text-[22px] font-semibold">
                {trans('tour.dates.start')}
            </h3>
            <span class="text-center font-semibold">
                {trans('tour.dates.months_select')}
            </span>

            <!-- DESKTOP -->
            <div class="hidden desktop:block">
                <VisibleDatesDesktop
                    {minPricePerMonths}
                    minPricePerDays={cheapestDailyPrices}
                    closedSales={closedSalesFormatted}
                    {isBookable}
                    {handleSelectedDate}
                />
            </div>

            <!-- MOBILE -->
            <div class="desktop:hidden">
                <VisibleDatesMobile
                    {minPricePerMonths}
                    minPricePerDays={cheapestDailyPrices}
                    closedSales={closedSalesFormatted}
                    {isBookable}
                    {handleSelectedDate}
                />
            </div>
        </div>
    </div>
{/if}
